/**
 * The Pipelines (CDP) source catalog: the integrations a workspace can add as a
 * source, and each one's manifest. Served by the CDP backend at
 * `/cdp/api/workspaces/{id}/available_sources` and
 * `/cdp/api/workspaces/{id}/action_sources/{optionId}/manifest`, which has no
 * OpenAPI spec, so the client is hand-written (see `client.ts`).
 */

export interface SourceSyncTemplate {
  sync_type: string;
  title: string;
  subtitle: string;
  destination_icon: string;
  record_type: string;
  cdp_type: string;
  fields: string[];
  email_field?: string;
  // Relationship templates carry both identifiers; the client cannot derive
  // them (e.g. AccountContactRelation's Contact.Email / AccountId).
  user_field?: string;
  group_field?: string;
}

export interface IntegrationMetadataLink {
  name: string;
  url: string;
}

export interface IntegrationMetadataItem {
  label: string;
  value?: string;
  links?: IntegrationMetadataLink[];
}

export interface AvailableSource {
  option_id: string;
  icon: string;
  name: string;
  content: string;
  learn_more_url: string;
  category: string;
  code?: string;
  /** The setup snippet for a source with a public `pk_` key, which needs no in-app site ID. */
  code_public_key?: string;
  type: string;
  language?: string;
  library_install_command?: string;
  library_install_instructions?: string;
  library_install_learn_more_url?: string;
  hidden: boolean;
  premium?: boolean;
  beta: boolean;
  connection_type: string;
  feature_flag: string;
  geolocation_supported: boolean;
  integration_description?: string;
  features?: string;
  requirements?: string;
  integration_metadata?: IntegrationMetadataItem[];
  sync_templates?: SourceSyncTemplate[];
}

export const cdpSourceOptionKeys = {
  all: (workspaceId: number) => ['workspace', workspaceId, 'cdp-source-option'] as const,
  lists: (workspaceId: number) => [...cdpSourceOptionKeys.all(workspaceId), 'list'] as const,
  manifest: (workspaceId: number, optionId: string) =>
    [...cdpSourceOptionKeys.all(workspaceId), 'manifest', optionId] as const,
  /** The key an inactive read parks on. Outside the workspace namespace, and never written. */
  inactive: (read: string) => ['cdp-source-option', 'inactive', read] as const,
};
